import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=e583c6b6&scoped=true"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=e583c6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e583c6b6",
  null
  
)

export default component.exports